import {
  JSResource,
  type SimpleEntryPoint,
} from "@loop-payments/react-router-relay";
import type { Customer } from "./Customer";
import CustomerQueryNode, {
  type CustomerQuery$variables,
} from "./__generated__/CustomerQuery.graphql";

const entryPoint: SimpleEntryPoint<typeof Customer> = {
  root: JSResource("Customer", () =>
    import("./Customer").then((module) => module.Customer),
  ),
  getPreloadProps({ params }) {
    const id = params.id!;
    const variables: CustomerQuery$variables = {
      id,
      onlyCustomer: [id],
    };

    return {
      queries: {
        query: {
          parameters: CustomerQueryNode,
          variables,
          options: {
            fetchPolicy: "store-and-network",
          },
        },
      },
    };
  },
};

export default entryPoint;
